import styled from "styled-components";

export const OurBranchesContainer = styled.div`
  padding: 30px 200px;
  background: #f9ecff;

  .heading {
    font-size: 32px;
    font-weight: bold;
  }

  .cards_container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 0px;
    column-gap: 20px;
    justify-items: center;
    align-items: center;

    @media (max-width: 1020px) {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 1280px) {
    padding: 30px 100px;
  }

  @media (max-width: 1020px) {
    grid-template-columns: 1fr;
    padding: 0px;

    .heading {
      font-size: 24px;
      text-align: center;
      padding-top: 20px;
    }
  }
`;

export const CalendarWrapper = styled.div`
  margin: 40px auto;
  max-width: 400px;
  display: none;

  &.show {
    display: block;
  }
`;

export const CalendarPopup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
`;

// Optional overlay for better UX
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 999;
`;